var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_516_915)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "#FDCBAC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_516_915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9536 25.9824H22.453V47.3953H33.9536V25.9824Z",
    fill: "#583A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5465 51.0641L27.9847 5.77389C14.4031 3.74761 13.0339 13.1671 13.0339 13.1671L11.0624 51.0641H27.5465Z",
    fill: "#7F492B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8675 51.0646C17.6889 42.0832 11.8291 43.1237 11.8291 43.1237C8.98138 43.288 8.37897 48.2716 8.26944 51.0646H16.8675Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3275 32.499H20.92V41.0971H27.3275V32.499Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5685 44.821C35.816 41.5351 34.0635 41.316 34.0635 41.316L27.3275 38.7969H20.92L14.184 41.316C14.184 41.316 11.391 42.0827 9.58379 44.821H37.5685Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3263 29.2135C30.1214 31.0755 28.5333 32.6089 26.3975 33.5947C25.6308 33.978 24.7545 34.3066 23.9331 34.4709C23.3306 34.6352 21.9615 35.0733 21.3591 34.7995C12.7063 31.0207 15.5541 14.4271 15.5541 14.4271C16.8684 6.48624 23.6592 6.54101 23.6592 6.54101C28.8071 6.32195 33.4621 8.73159 34.2835 14.1533C34.6121 16.2343 34.174 18.4249 34.0645 20.506C34.0097 22.0394 33.7907 23.5728 33.2978 24.9966C32.8049 26.5301 32.1477 27.9539 31.3263 29.2135Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4534 34.1966C26.287 33.9228 29.3538 30.9655 31.9277 28.2273C31.7634 28.5559 31.5444 28.9392 31.3253 29.2678C30.1205 31.1298 28.5323 32.6632 26.3965 33.649C25.6298 34.0323 24.7536 34.3609 23.9321 34.5252C23.3297 34.6895 21.9606 35.1276 21.3582 34.8538C19.989 34.2514 18.9485 33.3752 18.0723 32.2251C19.2771 33.0466 20.9748 34.3062 22.4534 34.1966Z",
    fill: "#E6AB86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5588 30.2534C31.3802 24.4483 31.4898 20.0124 27.0538 18.0409C24.0418 16.7265 16.4843 16.2336 16.4843 11.3048C16.4843 7.41656 20.3726 6.59509 23.5489 5.77362C28.3682 4.51404 35.4328 8.1285 36.6376 13.1668C36.6376 13.1121 38.6639 25.6531 30.5588 30.2534Z",
    fill: "#7F492B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6134 23.1889C30.6134 23.1889 31.2705 20.3411 33.4611 21.546C33.4611 21.546 34.4469 22.0388 33.7349 24.0104C33.7349 24.0104 32.6944 26.8034 30.6134 25.7628V23.1889Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.239 51.0642L38.2248 48.3807C37.1295 41.9185 34.1722 41.2066 34.1722 41.2066L29.0791 39.4541C29.0791 39.4541 26.1218 42.2471 21.6859 42.74C21.6859 42.74 19.331 41.7542 18.8381 39.6184L15.4427 40.878C15.4427 40.878 14.7855 44.1091 11.664 51.1189H37.239V51.0642Z",
    fill: "#3D823F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9384 51.0643L38.8836 50.5714C38.6098 43.3972 34.831 41.4805 34.831 41.4805C29.6832 41.8091 29.5189 47.5046 29.9022 51.0643H38.9384Z",
    fill: "#F8B78F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.161 24.8868V51.119H38.4995L37.7875 21.2723C37.7875 21.2723 38.6637 10.1551 31.2158 6.97876L28.9704 18.2055C28.9704 18.2055 30.8324 18.5341 31.161 24.8868Z",
    fill: "#7F492B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_915"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_516_915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.345,
    height: 50,
    fill: "white",
    transform: "translate(0 5.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.fb063084df50eb3b10c3d43b37205ef7.svg";
export { ForwardRef as ReactComponent };